module.exports = __webpack_public_path__ + "img/porc_francais.c3c0b84c.png";